import { liveChatComponentsStyles } from './liveChat-components.js';
import { liveChatCoreStyles } from './liveChat-core.js';
import { liveChatFeaturesStyles } from './liveChat-features.js';
import { liveChatViewsStyles } from './liveChat-views.js';

export const liveChatStyles =
	liveChatCoreStyles +
	liveChatViewsStyles +
	liveChatComponentsStyles +
	liveChatFeaturesStyles;

export {
	liveChatComponentsStyles,
	liveChatCoreStyles,
	liveChatFeaturesStyles,
	liveChatViewsStyles,
};
